// Static game configurations + FDJ-style theming (deterministic, no LLM).
export const GAMES = {
  loto: {
    id: "loto",
    name: "Loto Français",
    badge: "3 tirages / semaine",
    jackpot: "6 000 000 €",
    primary: "#0052CC",
    secondary: "#00A3E0",
    gradient: "from-[#0052CC] via-[#0066EE] to-[#00A3E0]",
    lightBg: "#EFF6FF",
    bonusName: "Numéro Chance",
    bonusType: "chance",
    pick: 5,
    max: 49,
    bonusPick: 1,
    bonusMax: 10,
    sumMin: 104,
    sumMax: 145,
    parityEvens: [2, 3],
    kenoMode: false,
  },
  euromillions: {
    id: "euromillions",
    name: "EuroMillions",
    badge: "Mardi & Vendredi",
    jackpot: "130 000 000 €",
    primary: "#1B3B8B",
    secondary: "#F5B301",
    gradient: "from-[#0B1E52] via-[#14307A] to-[#F5B301]",
    lightBg: "#FEF9E7",
    bonusName: "Étoiles",
    bonusType: "star",
    pick: 5,
    max: 50,
    bonusPick: 2,
    bonusMax: 12,
    sumMin: 105,
    sumMax: 152,
    parityEvens: [2, 3],
    kenoMode: false,
  },
  eurodreams: {
    id: "eurodreams",
    name: "EuroDreams",
    badge: "20 000€/mois pdt 30 ans",
    jackpot: "20 000 € / mois",
    primary: "#7C3AED",
    secondary: "#EC4899",
    gradient: "from-[#7C3AED] via-[#9333EA] to-[#EC4899]",
    lightBg: "#FAF5FF",
    bonusName: "Numéro Dream",
    bonusType: "dream",
    pick: 6,
    max: 40,
    bonusPick: 1,
    bonusMax: 5,
    sumMin: 100,
    sumMax: 146,
    parityEvens: [2, 3, 4],
    kenoMode: false,
  },
  keno: {
    id: "keno",
    name: "Keno",
    badge: "1 tirage / soir",
    jackpot: "100 000 € à vie",
    primary: "#8C0E36",
    secondary: "#E11D48",
    gradient: "from-[#5E0A24] via-[#9B1B3A] to-[#E11D48]",
    lightBg: "#FDF2F5",
    bonusName: "",
    bonusType: "keno",
    pick: 10, // user-selectable 2..10
    max: 70,
    bonusPick: 0,
    bonusMax: 0,
    sumMin: null,
    sumMax: null,
    parityEvens: null,
    kenoMode: true,
  },
};

export const GAME_ORDER = ["loto", "euromillions", "eurodreams", "keno"];

export const STRATEGIES = [
  { id: "balanced", label: "Équilibré", desc: "Parité 2/3 ou 3/2, somme dans la cloche de Gauss" },
  { id: "delay", label: "Écarts / Retards", desc: "Priorise les numéros en retard de sortie" },
  { id: "anti_share", label: "Anti-partage", desc: "Évite les dates d'anniversaire (numéros ≤ 31)" },
];
